<!-- Do not change this file. -->

<template>
  <div>
    <VersionCheck @update-available="hasUpdate = true" />
    <div class="container-fluid border-top py-2 text-small">
      <div class="d-flex justify-content-between" role="contentinfo">
        <div class="text-start my-auto">
          &copy; {{ year }} Oregon State University
        </div>

        <div class="text-end d-flex">
          <div class="my-auto">
            <TheDebugger />
          </div>
          <RouterLink
            :to="{ name: 'Participants' }"
            v-if="isAdmin"
            class="nav-link ms-3 my-auto text-primary"
            >Admin</RouterLink
          >
          <RouterLink
            :to="{ name: 'Activity' }"
            v-if="isAdmin && $route.name === 'Admin'"
            class="nav-link ms-3 my-auto text-primary"
            >Activity</RouterLink
          >
          <button
            class="btn btn-link m-0 p-0 my-auto ms-3"
            @click="toggleVersion"
          >
            {{ version }}
            <span v-if="hasUpdate" class="badge badge rounded-pill bg-danger"
              >Update available</span
            >
          </button>
          <button
            class="btn btn-link m-0 p-0 my-auto ms-3"
            @click="openDataCollectionModal"
          >
            Data Collection
          </button>

          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/digital-millennium-copyright-act"
            >Copyright</a
          >

          <a
            class="ms-3 my-auto"
            rel="noopener"
            target="_blank"
            href="https://oregonstate.edu/official-web-disclaimer"
            >Disclaimer</a
          >
        </div>
      </div>
    </div>
    <DataCollectionModal ref="dataCollectionModal" />
  </div>
</template>

<script>
/* Do not change this file. */
import TheDebugger from "@/components/debug/TheDebugger.vue";
import DataCollectionModal from "@/components/core/DataCollectionModal.vue";
import VersionCheck from "@/components/core/VersionCheck.vue";
import { version } from "@/../package.json";

import { mapGetters } from "vuex";
import config from "@/data/config.json";

export default {
  name: "TheFooter",
  components: {
    TheDebugger,
    DataCollectionModal,
    VersionCheck
  },
  data: () => {
    return {
      publishedYear: config.meta.publishedYear,
      showVersion: false,
      hasUpdate: false
    };
  },
  computed: {
    ...mapGetters(["isAdmin"]),
    year() {
      const currentYear = new Date().getFullYear(); // YYYY

      let yearString = "";
      /* Return just a single year */

      if (currentYear === this.publishedYear) {
        yearString = `${currentYear}`;
      } else {
        /* Return a year range */
        yearString = `${this.publishedYear} - ${currentYear}`;
      }

      return yearString;
    },
    version() {
      if (this.showVersion) {
        return document.lastModified;
      } else {
        return version;
      }
    }
  },
  methods: {
    toggleVersion() {
      this.showVersion = !this.showVersion;
    },
    openDataCollectionModal() {
      this.$refs.dataCollectionModal.openModal();
    }
  }
};
</script>

<style scoped>
.text-small {
  font-size: 0.8em;
}

.btn {
  font-size: inherit;
}

a,
.btn {
  text-decoration: none;
}

a:hover,
.btn:hover {
  text-decoration: underline;
}
</style>
